import React from 'react';
import { SectionWrapper } from './ui/SectionWrapper';
import { Trophy, CheckCircle2, Gift, Target } from 'lucide-react';
export function ProductSection() {
  return <>
      <SectionWrapper className="text-center" data-id="element-186">
        <h2 className="text-2xl md:text-4xl font-extrabold mb-8 md:mb-16 text-white" data-id="element-187">
          🧠 ¿Y SI ESTE FUERA EL MOMENTO DE ACTUAR?
        </h2>

        <div className="bg-white border border-blue-500/30 rounded-2xl md:rounded-[2rem] p-5 md:p-12 relative shadow-2xl" data-id="element-188">
          <div className="absolute -top-6 md:-top-8 left-1/2 -translate-x-1/2 bg-brand-blue text-white p-3 md:p-4 rounded-full shadow-lg shadow-brand-blue/30" data-id="element-189">
            <Trophy className="w-6 h-6 md:w-8 md:h-8" data-id="element-190" />
          </div>

          <div className="mb-8 md:mb-12 mt-4" data-id="element-191">
            <h3 className="text-brand-blue font-black tracking-widest uppercase mb-2 md:mb-4 text-sm md:text-base" data-id="element-192">
              DIGITALPREMIUM™
            </h3>
            <h4 className="text-2xl md:text-5xl font-extrabold text-brand-navy mb-3 md:mb-6" data-id="element-193">
              Sistema Completo para Proteger a tus Hijos
            </h4>
            <p className="text-base md:text-xl text-brand-textLight font-medium" data-id="element-194">
              50 módulos prácticos — directo al punto — sin relleno
            </p>
          </div>

          <div className="text-left bg-slate-50 rounded-xl md:rounded-2xl p-5 md:p-8 border border-slate-200 mb-8 md:mb-12" data-id="element-195">
            <h5 className="text-lg md:text-2xl font-bold mb-5 md:mb-8 flex items-center gap-2 md:gap-3 text-brand-navy" data-id="element-196">
              <span className="text-brand-blue" data-id="element-197">📘</span> ¿QUÉ INCLUYE?
            </h5>
            <ul className="grid md:grid-cols-2 gap-3 md:gap-4" data-id="element-198">
              {['Cómo funciona el mundo digital de los chicos', 'Cómo operan las redes sociales (explicado simple)', 'Riesgos reales: grooming, bullying, adicción', 'Señales de alerta que tenés que detectar', 'Cómo protegerlos paso a paso', 'Qué hacer HOY en tu casa', 'Cómo hablar con tus hijos sin rechazo', 'Cuándo darles un celular (y cómo hacerlo bien)'].map((item, i) => <li key={i} className="flex items-start gap-2 md:gap-3" data-id="element-199">
                  <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-brand-blue shrink-0" data-id="element-200" />
                  <span className="text-sm md:text-base text-brand-text font-medium" data-id="element-201">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-xl md:rounded-2xl p-5 md:p-8 text-left max-w-3xl mx-auto" data-id="element-202">
            <h5 className="text-base md:text-xl font-bold mb-4 md:mb-6 flex items-center gap-2 md:gap-3 text-brand-blue" data-id="element-203">
              <Target className="w-5 h-5 md:w-6 md:h-6" data-id="element-204" /> RESULTADO
            </h5>
            <div className="space-y-3 md:space-y-4" data-id="element-205">
              <p className="text-base md:text-xl font-bold text-brand-navy flex items-center gap-2 md:gap-3" data-id="element-206">
                <span className="text-brand-blue" data-id="element-207">👉</span> Entendés lo que
                antes no veías
              </p>
              <p className="text-base md:text-xl font-bold text-brand-navy flex items-center gap-2 md:gap-3" data-id="element-208">
                <span className="text-brand-blue" data-id="element-209">👉</span> Sabés qué mirar
              </p>
              <p className="text-base md:text-xl font-bold text-brand-navy flex items-center gap-2 md:gap-3" data-id="element-210">
                <span className="text-brand-blue" data-id="element-211">👉</span> Sabés cómo actuar
              </p>
            </div>
          </div>
        </div>
      </SectionWrapper>

      <SectionWrapper className="bg-brand-darkAlt border-y border-slate-800" data-id="element-212">
        <div className="bg-white shadow-xl rounded-2xl md:rounded-3xl p-5 md:p-12" data-id="element-213">
          <div className="flex flex-col items-center text-center mb-6 md:mb-10" data-id="element-214">
            <div className="bg-blue-50 text-brand-blue p-3 md:p-4 rounded-full mb-3 md:mb-4" data-id="element-215">
              <Gift className="w-6 h-6 md:w-8 md:h-8" data-id="element-216" />
            </div>
            <h3 className="text-2xl md:text-3xl font-extrabold text-brand-navy" data-id="element-217">
              INCLUYE BONUS
            </h3>
          </div>

          <div className="grid md:grid-cols-2 gap-3 md:gap-4" data-id="element-218">
            {['Checklist de control parental', 'Plan de acción inmediato', 'Sistema de configuración básica', 'Frases clave para hablar con tus hijos'].map((bonus, i) => <div key={i} className="bg-slate-50 border border-slate-200 rounded-lg md:rounded-xl p-4 md:p-6 flex items-center gap-3 md:gap-4" data-id="element-219">
                <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-brand-blue shrink-0" data-id="element-220" />
                <span className="font-bold text-sm md:text-lg text-brand-navy" data-id="element-221">
                  {bonus}
                </span>
              </div>)}
          </div>
        </div>
      </SectionWrapper>
    </>;
}